
define('text!templates/mx-error-msg.html',[],function () { return '<div class="alert alert-{{=it.level}}">\n    {{=it.msg}}\n</div>\n';});

